<template>
  <article class="popup popup-padding add-thing-popup">
    <header class="popup-top">
      <h2 class="title" v-if="type === 'multi'">
        {{$t('btns.things.addMultiThing')}}
      </h2>
      <h2 class="title" v-else>{{$t('btns.things.addThing')}}</h2>
      <div class="popup-top_btns">
<!--        prompts.addMultithing-->
        <question-btn :text="$t('prompts.addMultithing')" :bottom="true" v-if="type === 'multi'"></question-btn>
        <question-btn :text="$t('prompts.addThing')" :bottom="true" v-else></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <form class="add-thing-form" @submit.prevent="submitForm">
      <label class="input-cont input-cont_small" :class="{'error': $v.name.$error}">
        <p class="label">{{$t('roles.filters.name')}}</p>
        <input type="text"
               v-model="name"
               @input="translateNameForTag"
               @blur="$v.name.$touch()"
               @focus="$v.name.$reset()"
               placeholder="Датчик 1">
        <errors v-show="$v.name.$error"></errors>
      </label>
      <label class="input-cont input-cont_small"
             :class="{'error': $v.tag.$error}">
        <p class="label">{{$t('btns.things.tagName')}}</p>
        <input type="text"
               v-model="tag"
               @input="translateTag"
               @blur="$v.tag.$touch()"
               @focus="$v.tag.$reset()"
               placeholder="datchick_1">
        <errors v-show="$v.tag.$error"></errors>
      </label>
      <upload-avatar :label="$t('things.add.uploadThingAvatar')"
                     @del="avatarFile = ''"
                     class="avatar-cont"
                      @upload="avatarFile = $event"></upload-avatar>
<!--      <div class="select-cont select-cont_multiple" v-if="$route.name !== 'things'">-->
<!--        <p class="label">{{$t('btns.things.thingOwner')}}</p>-->
<!--        <v-select multiple-->
<!--                  :searchable="true"-->
<!--                  v-model="users"-->
<!--                  :clearable="false"-->
<!--                  label="email"-->
<!--                  :options="usersArr"></v-select>-->
<!--      </div>-->
<!--      <div  class="select-cont select-cont_multiple" v-if="$route.name !== 'things'">-->
<!--        <p class="label">-->
<!--          {{$t('btns.things.thingOwnerRole')}}-->
<!--        </p>-->
<!--        <v-select multiple-->
<!--                  :searchable="true"-->
<!--                  v-model="roles"-->
<!--                  :clearable="false"-->
<!--                  label="name"-->
<!--                  :options="rolesArr"></v-select>-->
<!--      </div>-->
<!--      уровни доступа временно закоментирую-->
<!--      <permission-toggler v-if="showPermissions"-->
<!--                          @level="level = $event"-->
<!--                          class="permission-toggler"></permission-toggler>-->
      <label class="textarea-wrap">
        <p class="label">{{$t('forms.descLb')}}</p>
        <textarea v-model="desc"
                  :placeholder="$t('forms.descPl')"></textarea>
      </label>
      <div class="btns-bottom">

<!--        кпопка отмена-->
        <button type="button"
                :disabled="loading"
                @click="closeAll();cancelMerge()"
                class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
<!--        кнопка создать вещь сработает сабмит формы с submitForm -->
        <button type="submit"
                :disabled="!name || loading || disabled"
                :class="{'loading': loading}"
                class="btn btn-blue">{{$t('btns.create')}}</button>

      </div>
    </form>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import questionBtn from '../questionBtn'
  import {popups} from "../../../mixins/popups";
  import errors from '../../Forms/errors'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {mapState,mapMutations,mapActions} from 'vuex'
  import {required} from 'vuelidate/lib/validators'
  import {filters} from "../../../mixins/filters";
  import uploadAvatar from '../../uploadAvatar'
  import {toFormData} from "../../../mixins/utils/toFormData";
  import {addThing} from "../../../mixins/things/addThings";
  import {showOverlay} from "../../../mixins/utils/showOverlay";

  export default {
    name: 'addThingPopup',
    mixins: [popups,tokenAndRoute, filters, toFormData, addThing, showOverlay],
    components: {
      closeBtn,
      questionBtn,
      errors,
      uploadAvatar,
    },
    data() {
      return {
        name: '',
        tag: '',
        virtual: false,
        desc: '',
        loading: false,

        avatarFile: '',
      }
    },
    computed: {
      ...mapState({
        //меняет название заголовка создать вещь или мультивещь через v-if
        type: state => state.popups.addThing.type,
        //в консоль приходит какая то пустота
        virtualThing: state => state.things.device,
        checkedThingsStore: state => state.things.checkedThingList,
      }),
      //this.$route.name всегда things , даже если кликнули по созданию мультивещи на плюсике
      isVirtual() {
        return this.$route.name === 'virtualThingList'
      },
      disabled() {
        return (!this.name || !this.tag)
      }
    },

    methods: {
      ...mapMutations({
        showAddThingPopup: 'popups/addThing/SET_SHOW',
        setType: 'popups/addThing/SET_TYPE',
        setMergeGroup: 'things/SET_MERGE_GROUP',
        setMergeVirtual: 'things/SET_MERGE_VIRTUAL'
      }),
      ...mapActions({
        createThing: 'things/createDevice',
        // createGroup: 'things/createDeviceGroup',
        // setPermissions: 'things/setPermissions',
        // getGroup: 'things/getGroup',
        updateDevice: 'things/updateDevice',
        getDevice: 'things/getDevice',
        getOwnedDevices: 'things/getDevices',
        getProjects: 'projects/getProjects'
      }),
      translateNameForTag() {
        this.tag = this.replacer(this.name)
      },
      translateTag() {
        this.tag = this.replacer(this.tag)
      },
      cancelMerge() {
        this.setMergeGroup(false);
        this.setMergeVirtual(false);
      },
      submitForm() {
        //если изВиртуал фолс запускаем функцию addThing
        if (!this.isVirtual && this.checkedThingsStore.length < 1) {
          this.addThing()
            //или запускаем addThingVirtual для создания виртуальной вещи
        } else {
          this.addThingVirtual()
        }
      },
      async addThingVirtual() {
        this.loading = true;

        /*let users = this.users.map(item => {
          return item.id
        });
        let subdevices = [];
        this.virtualThing.included_devices.forEach((item) => {
          subdevices.push(item.id)
        });

        users = users.join(',');*/

        let data = {
         // access_token: this.token,
          name: this.name,
          system_name: this.tag,
          description: this.desc,
          // users,
          virtual: 0,
          status: 1,
          image: this.avatarFile,

          source: 1,
          source_connect_token: 1
        };
        if (this.$route.params.item) {
          data.project_item_id = this.$route.params.item
        }
        if (this.type === 'multi') {
          data.virtual = 1;
        };

        if (this.isVirtual && this.$route.params.id) {
          data.parent_device_id = this.$route.params.id
        }

        let formData = this.toFormData(data);
        await this.createThing(formData).then(async res => {
          let id = res.id;
          /*subdevices.push(id);
          subdevices = subdevices.join(',');*/

          /*this.checkedThingsStore.forEach(item => {
            let updateObj = {
              // access_token: this.token,
              device_id: item.id,
              parent_device_id: id,
              source: 1,
              source_connect_token: 1
            };
            let formData = this.toFormData(updateObj);
            console.log('updateObj ', updateObj)
            this.updateDevice(formData);
          });*/

          /*if (this.showPermissions) {

            let rolesIds = this.roles.map(item => {
              return item.id
            }).join(',');
            let emails = this.users.map(item => {
              return item.email
            }).join(',');
            let object_name = 'device';


            let dataPermissions = {
            //  access_token: this.token,
              object_id: id,
              object_name,
              value: this.level
            };
            if (rolesIds) {
              dataPermissions.roles_ids = rolesIds
            };
            if (emails) {
              dataPermissions.emails = emails
            };
            let permissionObj = {
              data: dataPermissions,
              token: this.token
            };

            this.setPermissions(permissionObj)
          }*/
        }).finally(async res => {
          await this.getProjects()
          await this.getOwnedDevices()
          this.getDevice(this.routeId);
          this.showOverlay(false);
          this.showAddThingPopup(false)
          this.setType('')
          this.loading = false;
        });
      },

      async addThing() {
        this.loading = true;
        // let users = this.users.map(item => {
        //   return item.id
        // });
        // users = users.join(',');
        let data = {
        //  access_token: this.token,
          name: this.name,
          system_name: this.tag,
          description: this.desc,
          // users,
          virtual: 0,
          image: this.avatarFile,
          // project_item_id: this.$route.params.id,
          // project_item_id: 10,
          source: 1,
          source_connect_token: 1
        };

        if (this.$route.params.item) {
          data.project_item_id = this.$route.params.item
          // return false
        }

        if (this.$route.params.id && !this.$route.params.item) {
          data.project_id = this.$route.params.id
          // return false
        }


        if (this.type === 'multi') {
          data.virtual = 1;
        };
        /*if (this.groupId) {
          let groupId = this.$route.params.id
          data.group_id = groupId
        }*/

        // let formData = this.toFormData(data);
        let formData = new FormData

        for (let key in data) {
          formData.append(key, data[key])
        }

        await this.createThing(formData).then(() => {
          this.getProjects().then(() => {
            this.loading = false;
          })
        })
        // await this.createThing({data: formData, token: this.token}).then((res) => {
        //   this.loading = false;


          // if (this.showPermissions) {
          //   let id = res.id;
          //
          //   let rolesIds = this.roles.map(item => {
          //     return item.id
          //   }).join(',');
          //   let emails = this.users.map(item => {
          //     return item.email
          //   }).join(',');
          //   let object_name = 'device';
          //   if (this.type === 'group') {
          //     object_name = 'group'
          //   }
          //
          //   let dataPermissions = {
          //   //  access_token: this.token,
          //     object_id: id,
          //     object_name,
          //     value: this.level
          //   };
          //   if (rolesIds) {
          //     dataPermissions.roles_ids = rolesIds
          //   };
          //   if (emails) {
          //     dataPermissions.emails = emails
          //   };
          //
          //   let permissionObj = {
          //     data: dataPermissions,
          //     token: this.token
          //   };
          //   if (this.groupId) {
          //     permissionObj.group = true;
          //   }
          //
          //   // Этот метод здесь уже не нужен, возможно его нужно убрать из addThingVirtual и addGroup
          //   // this.setPermissions(permissionObj)
          // };

        //   if (this.groupId) {
        //     this.getGroup({token: this.token, id: this.routeId})
        //   }
        // }).catch(e => {
        //   this.loading = false
        // });
        this.showOverlay(false);
        this.showAddThingPopup(false)
        this.setType('')
      },
      // async addGroup() {
      //   this.loading = true;
      //   let data = {
      //     //access_token: this.token,
      //     name: this.name,
      //     description: this.desc,
      //     image: this.avatarFile
      //   };
      //
      //   if (this.groupId) {
      //     let groupId = this.$route.params.id
      //     data.parent_group_id = groupId
      //   }
      //
      //   let formData = this.toFormData(data)
      //
      //   await this.createGroup({data: formData, token: this.token}).then((res) => {
      //
      //     this.loading = false;
      //     if (this.showPermissions) {
      //       let id = res.id;
      //
      //
      //       let rolesIds = this.roles.map(item => {
      //         return item.id
      //       }).join(',');
      //       let emails = this.users.map(item => {
      //         return item.email
      //       }).join(',');
      //       let object_name = 'group';
      //
      //       let dataPermissions = {
      //        // access_token: this.token,
      //         object_id: id,
      //         object_name,
      //         value: this.level
      //       };
      //       if (rolesIds) {
      //         dataPermissions.roles_ids = rolesIds
      //       };
      //       if (emails) {
      //         dataPermissions.emails = emails
      //       };
      //
      //       let permissionObj = {
      //         data: dataPermissions,
      //         token: this.token
      //       };
      //       if (this.groupId) {
      //         permissionObj.group = true;
      //       }
      //
      //       this.setPermissions(permissionObj)
      //     };
      //
      //     if (this.groupId) {
      //       this.getGroup({token: this.token, id: this.routeId})
      //     }
      //   })
      //     .catch(e => {
      //       console.log(e);
      //     this.loading = false
      //   });
      //   this.showOverlay(false);
      //   this.showAddThingPopup(false);
      //   this.setType('')
      // }
    },
    validations: {
      name: {
        required
      },
      tag: {
        required
      }
    },
    destroyed() {
      this.setType('')
    }
  }
</script>

<style lang="scss" scoped>
  .input-cont {
    margin-bottom: 20px;
  }

  .check-cont {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .avatar-cont {
    margin-bottom: 20px;
  }

  .select-cont_multiple {
    margin-bottom: 20px!important;
  }

  .add-thing-popup {
    max-height: 600px;
    // top: calc(50% - 500px);
    overflow-y: scroll;

    @include scrollbal(5px)
  }

  .permission-toggler {
    margin-bottom: 20px;
  }
</style>
